import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import MainLayout from '../components/Layout/MainLayout';
import styles from '../assets/styles/ProjectQuota.module.scss';

const REQUEST_KEY_STORAGE = 'project-add-request-key';

interface ProjectQuota {
  default_project_count: number;
  additional_project_count: number;
  total_project_count: number;
  used_project_count: number;
}

const RequestAddProject: React.FC = () => {
  const navigate = useNavigate();
  const [quota, setQuota] = useState<ProjectQuota | null>(null);
  const [additionalCount, setAdditionalCount] = useState(0);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadQuota = async () => {
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/project-quota`, {
          credentials: 'include',
        });
        if (!response.ok) throw new Error('quota');
        setQuota(await response.json());
      } catch (loadError) {
        console.error('Project quota fetch error:', loadError);
        setError('プロジェクト情報の取得に失敗しました。');
      }
    };
    void loadQuota();
  }, []);

  const changeCount = (delta: number) => {
    setAdditionalCount((current) => Math.min(99, Math.max(0, current + delta)));
  };

  const handleProceed = () => {
    sessionStorage.setItem(REQUEST_KEY_STORAGE, crypto.randomUUID());
    navigate('/confirm-add-project', { state: { additionalCount } });
  };

  return (
    <MainLayout title="プロジェクト追加申請">
      <main className={styles.page}>
        <section className={styles.card}>
          <h1 className={styles.title}>プロジェクト追加申請</h1>
          {error && <p className={styles.error}>{error}</p>}
          {quota && (
            <>
              <dl className={styles.quotaList}>
                <dt>デフォルトPJ数</dt><dd>{quota.default_project_count}</dd>
                <dt>追加済みPJ数</dt><dd>{quota.additional_project_count}</dd>
                <dt>合計PJ数</dt><dd>{quota.total_project_count}</dd>
                <dt>使用済みPJ数</dt><dd>{quota.used_project_count}</dd>
              </dl>
              <p>追加するPJ数</p>
              <div className={styles.counter}>
                <button type="button" className={styles.counterButton} onClick={() => changeCount(-1)}>-</button>
                <span className={styles.counterValue}>{additionalCount}</span>
                <button type="button" className={styles.counterButton} onClick={() => changeCount(1)}>+</button>
              </div>
              <p className={styles.fee}>月額費用: <strong>+{(additionalCount * 100).toLocaleString()}円/月</strong></p>
              <div className={styles.actions}>
                <button type="button" className={styles.secondaryButton} onClick={() => navigate('/board')}>キャンセル</button>
                <button
                  type="button"
                  className={styles.primaryButton}
                  onClick={handleProceed}
                >
                  決定
                </button>
              </div>
            </>
          )}
        </section>
      </main>
    </MainLayout>
  );
};

export default RequestAddProject;
